/** `React.useId()` returns `:r0:`, whose colons are CSS combinators, so a composed id is normalised here. */
export const sanitiseDomId = (value: string): string => value.replace(/[^A-Za-z0-9_-]/g, '-');
